import React, { ReactNode } from 'react';
import classNames from 'classnames';

import { IconButton, InfoIcon } from '../../../../';
import { Tooltip } from '../../popovers';

import styles from './TwoColumnTable.module.css';

export interface TwoColumnTableTheme {
  TwoColumnTable: string;
  Row: string;
  Value: string;
  Label: string;
}

export interface TwoColumnTableProps {
  valueWidth?: string;
  rows: Array<{
    label: string | number | ReactNode | null;
    value: string | number | ReactNode | null;
    tooltipContent?: string | number | ReactNode;
    badges?: ReactNode;
  }>;
  theme?: Partial<TwoColumnTableTheme>;
  dataHcName?: string;
  badgesEnabled?: boolean;
  compact?: boolean;
  borders?: boolean;
  blurred?: boolean;
}

export const TwoColumnTable = ({
  valueWidth,
  rows,
  theme,
  badgesEnabled,
  dataHcName,
  compact = false,
  borders = false,
  blurred = false,
}: TwoColumnTableProps) => {
  return (
    <div
      data-hc-name={dataHcName}
      className={classNames(
        styles.TwoColumnTable,
        {
          [styles.badgesEnabled]: badgesEnabled,
          [styles.borders]: borders,
          [styles.compact]: compact,
          [styles.blurred]: blurred,
        },
        theme?.TwoColumnTable,
      )}
    >
      {rows.map((row, index) => {
        return (
          <div
            key={index}
            data-hc-name={`${dataHcName}-row`}
            className={classNames(
              styles.Row,
              { [styles.LastRow]: rows.length - 1 === index },
              theme?.Row,
            )}
            style={
              valueWidth
                ? {
                    gridTemplateColumns: `2fr ${valueWidth} ${
                      badgesEnabled ? '100px' : ''
                    }`,
                  }
                : undefined
            }
          >
            <div
              className={classNames(styles.Label, theme?.Label)}
              data-hc-name={`${dataHcName}-label-${index}`}
            >
              {row.label}
              {row.tooltipContent && (
                <Tooltip
                  theme={{
                    Button: styles.PopoverButton,
                  }}
                  key={index}
                  label={row.tooltipContent}
                  dataHcName={`${dataHcName}-popover`}
                  trigger={
                    <IconButton
                      dataHcName={'two-column-table-info-icon'}
                      icon={<InfoIcon size="sm" color="neutral-dark-40" />}
                    />
                  }
                />
              )}
            </div>
            <div
              className={classNames(styles.Value, theme?.Value)}
              data-hc-name={`${dataHcName}-value-${index}`}
            >
              {row.value}
            </div>
            {badgesEnabled && row.badges && (
              <div data-hc-name={`${dataHcName}-badges`}>{row.badges}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};
